import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import jwtDecode from 'jwt-decode';

var isValidToken = function isValidToken() {
  var expiresAt = Number(localStorage.getItem('MDM_ACCESS_TOKEN_EXPIRES_AT'));
  return !!(localStorage.getItem('MDM_ACCESS_TOKEN') && new Date().getTime() < expiresAt);
};

var decodedToken = function decodedToken() {
  return jwtDecode(localStorage.getItem('MDM_ACCESS_TOKEN'));
};

var hasApiAudience = function hasApiAudience(_ref) {
  var apiName = _ref.apiName;

  var _decodedToken = decodedToken(),
      aud = _decodedToken.aud;

  return Array.isArray(aud) && aud.includes(apiName) || aud === apiName;
};

var hasToken = function hasToken() {
  return !!localStorage.getItem('MDM_ACCESS_TOKEN');
};

export { isValidToken, hasApiAudience, decodedToken, hasToken };